module.exports = __webpack_public_path__ + "img/tu.c8553e58.png";